import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractFormWidgetComponent } from '../abstract-form-widget/abstract-form-widget.component';
import { SearchService } from '../../../search/search.service';
import { KittingDataService } from '../../../../features/inventory/vas/kitting/services/kitting-data.service';
import { SearchEvent } from '../../../search/models/search-event';
import { KittingButtonService } from '../../../../features/inventory/vas/kitting/services/kitting-button.service';
import { NEW_SEARCH_EVENT, NEW_ROW_EVENT, PAGE_OVERFLOW_EVENT, REFRESH_SEARCH_EVENT } from '../../../search/search-constants';
import { Subscription } from 'rxjs';
import { ViewBalancesCellRendererComponent } from '../../common/view-balances-popup/view-balances-cell-renderer/view-balances-cell-renderer.component';
import { SubscriptionUtils } from '../../../utils/subscription-utils';

@Component({
  selector: 'lfwms-kitting-detail-table-widget',
  templateUrl: './kitting-detail-table-widget.component.html',
  styleUrls: ['./kitting-detail-table-widget.component.css']
})
export class KittingDetailTableWidgetComponent extends AbstractFormWidgetComponent implements OnInit, OnDestroy  {
  /*Kitting screen needs to data tables i.e. from detail list and to
  detail list. This component loads two data tables based on the corresponding
  search services */
  public searchService: SearchService;
  public dataService: KittingDataService;
  public buttonService: KittingButtonService;
  private subscriptionLists: Array<Subscription>;
  protected resultSearchServiceEventSubscription: Subscription;
  public aggregateRecordsArray: any = [];
  public showAggregateSection: boolean;
  public ngOnInit() {
    this.subscriptionLists = [];
    this.buttonService = <KittingButtonService> this.pageConfig.buttonService;
    this.initializeWidget();
    //LFWM-2952- calling calculateTotalQty to calculate the total.
    if (this.widgetConfig.id === 'lbl_to_dtl') {
      this.calculateTotalQty();
    }
    const detailsSearchEventSubscription = this.searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.buttonService.initializeButtonsForPage(this.cellDataMap, 'details');
        if (event.type === NEW_SEARCH_EVENT &&
          this.searchService.getMetadata()) {
          // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
          this.pageConfig.isDetailSectionLoaded = true;
        } else if (event.type === NEW_ROW_EVENT) {
          if (this.widgetConfig.id === 'lbl_frm_dtl') {
            event.selectedRow.cells['type'].cVal = 'F';
          } else {
            event.selectedRow.cells['type'].cVal = 'T';
          }
          // For NEW_ROW_EVENT
          // for new row event the search service should also be passed to distinguish between the two tables
          this.dataService.setCurrentSearchService(this.widgetConfig.id);
          this.dataService.handleAddNewItem(event, this.searchService);
        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.searchService.setNewPageEventInProgress(true);
          this.buttonService.performButtonActions('Save');
        }
      });
      this.subscriptionLists.push(detailsSearchEventSubscription);
  }

  protected initializeWidget() {
    // this is not to be loaded from the primary data map, hence initializing it
    // this.pageConfig.cellDataMap = {};
    super.initializeWidget();
    this.searchService = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id);

    if (this.dataService.displayMode === 'C') {
      this.searchService.getPagedData().pageRows = [];
      // this.loadWidgetForCreate();
    } else {
      this.searchService.setSearchCriteria({
        conditions: [{
          mandatory: false,
          clauses: [{
            column: 'kitKey',
            operation: '=',
            value: this.dataService.getPrimarySelectedDocument(),
            logicalOperation: null
          }],
          logicalOperation: null
        }]
      });
      this.searchService.performSearch();
    }
  }

  // realigns the widget
  public realignWidget() {
    //  this.propertyList = this.preparePropertyGrid(this.widgetConfig.propertyList, this.getCellsPerRow());
  }
  // LFWM-2952- calculating the total values.
  private calculateTotalQty() {
    this.showAggregateSection = false;
    // giving the kitLineNumber as the propertyName in columnPinnedRendererMapping to specify the starting of pinned row.
    // at the column with this propertyName ViewBalancesCellRendererComponent is Rendered( template has value 'TOTAL', so TOTAL is rendered).
    this.searchService.searchParams.dataTableConfig.columnPinnedRendererMapping['kitLineNumber'] = ViewBalancesCellRendererComponent;
    this.resultSearchServiceEventSubscription = this.searchService.receiveEvent()
      .subscribe((event: SearchEvent) => {
        if (event.type === NEW_SEARCH_EVENT) {
          // need to clear aggregateRecordsArray for new search event
          this.aggregateRecordsArray = [];
          // method [getPinnedPayLoad] to create the pinned row for displaying the total 
          const pinnedPayload = this.getPinnedPayLoad();
          const enrichPayload: any = (data: any) => {
            this.searchService.pagedData.pageRows.forEach(row => {
              if (pinnedPayload && pinnedPayload.length !== 0) {
                // Use pinnedPayload[0] for array access
                let expectedQtyVal = 0;
                const expectedQtyCheck = row.cells && row.cells['expectedQty'] && row.cells['expectedQty'].cVal !== undefined;
                if (expectedQtyCheck) {
                  expectedQtyVal = parseInt(row.cells['expectedQty'].cVal, 10);
                }
                const expectedQtyToAdd = isNaN(expectedQtyVal) ? 0 : expectedQtyVal;
                pinnedPayload[0]['expectedQty']['cVal'] += expectedQtyToAdd;

                let qtyVal = 0;
                const qtyCheck = row.cells && row.cells['qty'] && row.cells['qty'].cVal !== undefined;
                if (qtyCheck) {
                  qtyVal = parseInt(row.cells['qty'].cVal, 10);
                }
                const qtyToAdd = isNaN(qtyVal) ? 0 : qtyVal;
                pinnedPayload[0]['qty']['cVal'] += qtyToAdd;
              }
            });
          };
          enrichPayload(this.searchService.pagedData.pageRows);
          this.searchService.getPagedData().pinnedPageRows = [pinnedPayload];
          this.searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        }
      });
  }
  // LFWM-2952-cVal of the column which needs total is initialized as '0'.
  public getPinnedPayLoad() {
    const pinnedPayload: any = [];
    const metadata = this.searchService.getMetadata();
    if (!metadata || !metadata.columnList) {
      return pinnedPayload;
    }
    metadata.columnList.forEach((column: any) => {
      if (column.propertyName === 'expectedQty' || column.propertyName === 'qty') {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: 0 };
      } else {
        pinnedPayload[column.propertyName] = { 'cName': column.propertyName, cVal: '' };
      }
    });
    pinnedPayload['isSelected'] = false;
    return pinnedPayload;
  }

  // unsubscribed on component destroy
  public ngOnDestroy() {
    SubscriptionUtils.safeUnsubscribe(this.subscriptionLists);
    this.dataService.handleDestroyDetails();
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/kitting-detail-table-widget/kitting-detail-table-widget.component.ts